import Discuss from './discuss';

export default Discuss;
